/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable, inject } from '@angular/core';
import { BuildingDataServiceEndpoints } from './building-data-service-end-points';
import { BaseApiService } from './base-api.service';
import { Configuration } from '../../../../../../../apps/sysque-electrical/src/app/configuration/configuration';
import { Environments } from '../../../../../../../apps/sysque-electrical/src/app/configuration/environments';
import { DocumentResult } from '@hcworkspace/sysque/toolbelt/data-access';
import { CurateSearchVm, QueryParams } from 'libs/sysque/toolbelt/feature/src/lib/models/curate-search-vm';
import { Store } from '@ngrx/store';
import { selectLastCurateSearchQuery } from '../../../../../toolbelt/feature/src/lib/+state/curate-search/curate-search-selector'; //libs/sysque/toolbelt/feature/src/lib/+state/curate-search/curate-search-selector';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BuildingDataApiService extends BaseApiService {
  apiDomain = '';
  version = 'v1';
  // curateSearchLastIndex: number = 0;
  curateSearchLastIndexMap: Map<number, number> = new Map();
  lastCurateSearchQuery!: CurateSearchVm;

  constructor(store: Store = inject(Store)) {
    super();
    store.select(selectLastCurateSearchQuery).subscribe((data) => {
      this.lastCurateSearchQuery = data as CurateSearchVm;
    });

    /***
     * !important:
     * We are asking all the time the production domain here.
     * We have to change it to the correct domain.
     * Solution: backend can send angular witch domain to use throw routing.
     * Example for the call: http://localhost:4200/?bdsDomain=dev&accesstoken=123
     * bdsDomain: building data service domain to use.
     *
     */
    this.apiDomain = Configuration.getBuildingDataServiceUrl(Environments.prod);
  }

  public async GetFittingDataByQuery(
    fittingDataQuery: QueryParams
  ): Promise<DocumentResult[]> {
    var documents: DocumentResult[] = [];
    fittingDataQuery.StartRecordIndex = 0;
    fittingDataQuery.RecordCount = 1000;

    const url = `${this.apiDomain}/${this.version}/${BuildingDataServiceEndpoints.PostFittingDataByQueryUrl()}`;
    const body = JSON.stringify(fittingDataQuery);

    try {
      let result = await this.post<any, any>(url, body)
        catchError(this.handleError);

      (result.data.documents as []).forEach((doc) => {
        documents.push(doc);
      });
    } catch (error) {
      console.error('Error fetching fitting data:', error);
    }

    return documents;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      console.error('An error occurred:', error.error.message);
    } else {
      // Backend returned an unsuccessful response code
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  public async getSizeData(fittingEntryId: number) {
    const sizes: string[] = [];
    const url = `${this.apiDomain}/${this.version}/${BuildingDataServiceEndpoints.GetFittingDataByFittingEntryId(
      fittingEntryId
    )}`;

    let dataDocument: any = await this.get(url, null);
    const fSizes = dataDocument['sizes'];

    fSizes.forEach((fittingSize: any) => {
      let size = '';
      if (fittingSize.decSizes == null) {
        return;
      }
      size = fittingSize.decSizes.reduce(
        (current: any, dSize: any) => current + (dSize.widthOrDiameter.toFixed(3) + 'x'),
        ''
      );
      if (fittingSize.decSizes.length > 0) {
        size = this.trimEnd(size, 'x');
      }
      sizes.push(size);
    });
    return sizes;
  }

  trimEnd(inputString: string, charToRemove: string): string {
    while (inputString.endsWith(charToRemove)) {
      inputString = inputString.slice(0, -charToRemove.length);
    }
    return inputString;
  }
}
